import type { ReactNode } from 'react';
type Props = {
  title: string;
  children: ReactNode;
};

/**
 * DEMO — het gestippelde vak met testgegevens. Met een backend tonen de schermen hem niet,
 * omdat de api-laag dan `null` doorgeeft (demoAdminLogin, demoTwoFactorHint).
 */
export function DemoHintBox({
  title,
  children
}: Props) {
  return <div className="mt-8 rounded-md border border-dashed border-line bg-shell px-4 py-3 text-[13px] leading-relaxed text-muted" data-id="element-3863" data-mp="2736vdjw2r5m6">
      <span className="text-ink" data-id="element-3864" data-mp="2c0yqems0n7ul">{title}</span>
      <br data-id="element-3865" data-mp="2gztfg6gktsn5" />
      {children}
    </div>;
}